<template>
  <div>
    <div v-show="!isLoading" class="myresources">
      <div class="myresources-uploadbtns">
        <div class="myresources-title" style="align-self: center;">書簽</div>
      </div>
      <div>
        <VideoPool :folders="folders" :showFilter="false" :actions="actions"></VideoPool>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<style lang="scss" scoped>
  .myresources{
    width: 80%;
    max-width: 1024px;
    margin: 2rem auto;
    padding-right: 2rem;
  }
  .myresources-uploadbtns{
    display: flex;
    justify-content: space-between;
  }
  .myresources-title{
    font-size: 1.5rem;
    font-weight: 600;
    color: #397f1f;
  }
  .myresources-btn{
    margin: 1rem;
    background-color: #3c7f1f;
    color: white;
    font-size: 1.2rem;
    padding: 1rem 1.5rem;
    border-radius: 0.8rem;
  }
  .myresources-btn:hover{
    cursor: pointer;
  }
  .myresources-filebtns{
    display: flex;
    flex-direction: row;
  }
  .myresources-filebtn{
    margin: 0.8rem;
    background-color: #3c7f1f;
    color: white;
    font-size: 1.2rem;
    text-align: center;
    padding: 4rem 0;
    border-radius: 0.8rem;
    flex: 0 0 15rem;
  }
  .myresources-fileTitle{
    font-size: 1.3rem;
    color: #3c7f1f;
    font-weight: 600;
    margin: 1.5rem 0;
  }
  .myresources-fileContent{
    border: 1px solid #99cc33;
    border-radius: 1.5rem;
  }
</style>
<script>
// import vuescroll from 'vuescroll'
import Loading from '@/components/Utility/Loading.vue'
import VideoPool from '@/components/Video/VideoPool.vue'
export default {
  components: {
    //  vuescroll,
    Loading,
    VideoPool
  },
  data () {
    return {
      isLoading: true,
      folders: [],
      actions: [{
      //   fn: this.addMission,
      //   name: '增加任務'
      // },
      // {
        fn: this.goToVideoDetail,
        name: '觀看影片'
      }]
    }
  },
  methods: {
    goToVideoDetail: function (file) {
      console.log(this.$router)
      this.$router.push({
        name: 'Video',
        query: {
          subject: file.parent_id,
          file: file.info.id
        }
      })
      console.log(file)
    }
  },
  async mounted () {
    await this.$store.dispatch('request', {
      route: `resources/bookmarked-list`
    }).then(result => {
      this.folders = result
    })
    this.isLoading = false
  }
}
</script>
